<!-- Blur backdrop (mobile only) -->
@if (isMenuOpen()) {
  <div
    class="fixed inset-0 z-30 backdrop-blur-xs bg-black/20 md:hidden"
    (click)="closeMenu()"
  ></div>
}

<nav
  class="w-full fixed top-0 left-0 z-40 animate-fade-in-down"
  [ngClass]="{
    'bg-main-blue-light': isScrolled() || isMenuOpen(),
    'bg-transparent': !isScrolled() && !isMenuOpen(),
    '2xl:bg-main-blue-light': !isScrolled() && !isMenuOpen(),
    'transition-colors duration-500 ease-in-out': true,
  }"
>
  <ul class="2xl:container 2xl:mx-auto flex items-center justify-between md:px-10 px-4 py-2.5">
    <li>
      <a routerLink="/"><img src="logo.png" alt="Yarrow Logo" class="h-10" /></a>
    </li>

    <!-- Desktop menu -->
    <li class="hidden md:flex items-center justify-center gap-10">
      <button
        class="text-white text-sm font-thin hover:underline transition-all duration-300 cursor-pointer"
        (click)="scrollToServices()"
      >
        Services
      </button>

      <!-- Language toggle -->
      <div class="flex items-center gap-0.5 text-sm font-medium">
        <button
          (click)="switchLanguage('en')"
          [class.text-white]="currentLocale === 'en'"
          [class.text-white/40]="currentLocale !== 'en'"
          class="cursor-pointer transition-all duration-200 hover:text-white px-1"
        >
          EN
        </button>
        <span class="text-white/30">|</span>
        <button
          (click)="switchLanguage('th')"
          [class.text-white]="currentLocale === 'th'"
          [class.text-white/40]="currentLocale !== 'th'"
          class="cursor-pointer transition-all duration-200 hover:text-white px-1"
        >
          TH
        </button>
      </div>

      <a
        class="bg-white text-main-blue-light flex items-center justify-center gap-2 text-sm px-5 py-2.5 rounded-full cursor-pointer hover:bg-main-blue hover:text-white transition-all duration-300 active:bg-main-blue active:scale-95"
        href="https://app.yarrowpass.com/discover"
        target="_blank"
      >
        <span>Join Our Game</span>
        <img src="open_in_new_blue.svg" alt="Open in new tab" class="w-4 h-4 inline-block" />
      </a>
    </li>

    <!-- Hamburger button (mobile only) -->
    <li class="flex md:hidden">
      <button
        class="text-white p-1 cursor-pointer focus:outline-none"
        (click)="toggleMenu()"
        aria-label="Toggle menu"
        i18n-aria-label="nav|Toggle mobile menu aria-label@@nav.toggleMenu"
      >
        @if (!isMenuOpen()) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        }
      </button>
    </li>
  </ul>

  <!-- Mobile dropdown -->
  @if (isMenuOpen()) {
    <div class="md:hidden flex flex-col animate-fade-in-down">
      <a
        class="text-main-blue-light text-center font-medium hover:bg-main-yellow hover:text-white transition-all duration-300 cursor-pointer bg-white w-full py-2.5"
        (click)="scrollToServices()"
        >Services</a
      >
      <a
        class="text-white text-center flex- font-medium hover:bg-main-yellow transition-all duration-300 cursor-pointer bg-main-blue-light w-full py-2.5 flex items-center justify-center gap-2"
        href="https://app.yarrowpass.com/discover"
        target="_blank"
      >
        <span>Join Our Game</span>
        <img src="open_in_new.svg" alt="Open in new tab" class="w-4 h-4 inline-block" />
      </a>
      <!-- Mobile language toggle -->
      <div
        class="bg-main-blue-light w-full py-2.5 flex items-center justify-center gap-2 text-sm font-medium"
      >
        <button
          (click)="switchLanguage('en')"
          [class.text-white]="currentLocale === 'en'"
          [class.text-white/40]="currentLocale !== 'en'"
          class="cursor-pointer transition-all duration-200 hover:text-white px-2"
        >
          EN
        </button>
        <span class="text-white/30">|</span>
        <button
          (click)="switchLanguage('th')"
          [class.text-white]="currentLocale === 'th'"
          [class.text-white/40]="currentLocale !== 'th'"
          class="cursor-pointer transition-all duration-200 hover:text-white px-2"
        >
          TH
        </button>
      </div>
    </div>
  }
</nav>
